export default {
  id: "supplierComparison",
  name: "",
  description: "",
  report: {
    name: "Supplier Comparison",
    chartType: "",
    template: "supplier-comparison",
    config: {
      dataType: "single",
      dataSet: "Supplier",
      measures: [],
      dimensions: [],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: true,
      filterDateRange: true,
    },
  },
};
